/**
 * @file danger-status.icon.tsx
 * @description Компонент для отображения иконки Критических ошибок.
 * @author Genotroid
 * @created 2025-09-03
 * @updated 2025-09-03
 * @dependencies []
 * @related-files []
 */

export const DangerStatusIcon = ({ color = '#FF3F3F', size = '1.9054vmin' }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9Z"
                fill={color}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.00056 3.85742C9.71064 3.85742 10.2863 4.33712 10.2863 4.92885V9.21457C10.2863 9.8063 9.71064 10.286 9.00056 10.286C8.29048 10.286 7.71484 9.8063 7.71484 9.21457V4.92885C7.71484 4.33712 8.29048 3.85742 9.00056 3.85742Z"
                fill="white"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.00056 11.5713C9.71064 11.5713 10.2863 12.1469 10.2863 12.857C10.2863 13.5671 9.71064 14.1427 9.00056 14.1427C8.29048 14.1427 7.71484 13.5671 7.71484 12.857C7.71484 12.1469 8.29048 11.5713 9.00056 11.5713Z"
                fill="white"
            />
        </svg>
    );
};
